import React from 'react';
import { Spinner } from 'react-bootstrap';
import DashboardMetricLabel from '../dashboard/DashboardMetricLabel';

const TeamMiniMetric = ({
  label,
  value,
  icon,
  color = 'primary',
  loading = false,
  helpText,
  suffix,
}) => (
  <div className={`team-mini-metric team-mini-metric--${color}`}>
    <div className="team-mini-metric__icon">
      <i className={icon} aria-hidden="true" />
    </div>
    <div className="team-mini-metric__content">
      <DashboardMetricLabel helpText={helpText} className="team-mini-metric__label">
        {label}
      </DashboardMetricLabel>
      <div className="team-mini-metric__value">
        {loading ? <Spinner animation="border" size="sm" /> : (
          <>
            {value ?? '—'}
            {suffix ? <span className="team-mini-metric__suffix">{suffix}</span> : null}
          </>
        )}
      </div>
    </div>
  </div>
);

export default TeamMiniMetric;
